import { FC } from 'react';

interface IconImageViewProps {
  className?: string;
  fill?: boolean;
  duotone?: boolean;
}

const IconImageView: FC<IconImageViewProps> = ({
  className,
  fill = false,
  duotone = true,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      viewBox="0 0 16 16"
      className={className}
    >
      <g fill="none" strokeLinecap="round" strokeLinejoin="round">
        <path
          stroke="#cad3f5"
          d="M4.5 4.5H12A1.5 1.5 0 0 1 13.5 6v.5m-7.5 7H2A1.5 1.5 0 0 1 .5 12V3.5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v1"
        />
        <path stroke="#a6da95" d="M14.5 15.5L11 12l-2.5 2.5" />
        <path
          stroke="#7dc4e4"
          d="M9.5 8.5h4.997a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H9.5a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1"
        />
        <circle cx="13.5" cy="10.5" r=".5" stroke="#eed49f" />
      </g>
    </svg>
  );
};

export default IconImageView;
